// extracted by mini-css-extract-plugin
module.exports = {"SettingsForm":"SettingsForm_SettingsForm__37RGc","Inputs":"SettingsForm_Inputs__5Kihj","EditIcon":"SettingsForm_EditIcon__3g4ty"};